import { render, staticRenderFns } from "./user_name.vue?vue&type=template&id=9c92b132&scoped=true&"
import script from "./user_name.vue?vue&type=script&lang=js&"
export * from "./user_name.vue?vue&type=script&lang=js&"
import style0 from "./user_name.vue?vue&type=style&index=0&id=9c92b132&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c92b132",
  null
  
)

export default component.exports